import React, { useState } from 'react';
import { Mail, Phone, MapPin, Instagram, Facebook, Twitter, ArrowRight, Check } from 'lucide-react';
import PageHeader from '@/components/ui/PageHeader';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  return (
    <div data-testid="page-contact">
      <PageHeader
        eyebrow="Say hello"
        title="We'd love to"
        accent="hear from you."
        description="Questions, partnerships, press, or just want to share which flavour you've fallen for — drop us a line."
      />

      <section className="container-x py-14 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <aside className="lg:col-span-5 space-y-5">
          <div className="glass-card rounded-3xl p-8 space-y-5">
            <InfoRow icon={<Mail className="w-4 h-4" />} label="Email" value="hello@siptheory.com" />
            <InfoRow icon={<Phone className="w-4 h-4" />} label="Phone" value="+91 98765 43210" />
            <InfoRow icon={<MapPin className="w-4 h-4" />} label="Studio" value="14, Botanical Lane, Bandra West, Mumbai 400050" />
          </div>
          <div className="glass-card rounded-3xl p-8">
            <h3 className="font-display text-xl text-bone-50">Find us on</h3>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" aria-label="Instagram" className="btn-ghost-icon"><Instagram className="w-4 h-4" /></a>
              <a href="#" aria-label="Facebook" className="btn-ghost-icon"><Facebook className="w-4 h-4" /></a>
              <a href="#" aria-label="Twitter" className="btn-ghost-icon"><Twitter className="w-4 h-4" /></a>
            </div>
            <p className="text-bone-300/80 text-sm mt-5">Mon–Sat · 10:00 – 19:00 IST</p>
          </div>
        </aside>

        <form
          onSubmit={(e) => { e.preventDefault(); setSubmitted(true); setTimeout(() => setSubmitted(false), 4000); }}
          data-testid="contact-form"
          className="lg:col-span-7 glass-card rounded-3xl p-8 lg:p-10 space-y-4"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field label="Name" testid="contact-name" required />
            <Field label="Email" type="email" testid="contact-email" required />
          </div>
          <Field label="Subject" testid="contact-subject" />
          <div>
            <label className="text-[11px] tracking-[0.22em] uppercase text-bone-300/80">Message <span className="text-gold">*</span></label>
            <textarea
              rows={6}
              required
              data-testid="contact-message"
              className="mt-2 w-full bg-ink-800 border border-bone-100/12 rounded-2xl px-4 py-3 text-sm text-bone-100 placeholder:text-bone-300/50 outline-none focus:border-gold/60"
              placeholder="Type your message…"
            />
          </div>
          <button type="submit" className="btn-primary" data-testid="contact-submit">
            Send Message <ArrowRight className="w-4 h-4" />
          </button>
          {submitted && (
            <p className="inline-flex items-center gap-2 text-sage-300 text-sm" data-testid="contact-success">
              <Check className="w-4 h-4" /> Message sent — we&apos;ll write back within 24 hours.
            </p>
          )}
        </form>
      </section>
    </div>
  );
}

const InfoRow = ({ icon, label, value }) => (
  <div className="flex items-start gap-4">
    <span className="w-10 h-10 rounded-full border border-gold/30 bg-gold/10 flex items-center justify-center text-gold shrink-0">{icon}</span>
    <div>
      <p className="text-[11px] tracking-[0.22em] uppercase text-bone-300/80">{label}</p>
      <p className="text-bone-100 mt-1">{value}</p>
    </div>
  </div>
);

const Field = ({ label, type = 'text', required, testid }) => (
  <div>
    <label className="text-[11px] tracking-[0.22em] uppercase text-bone-300/80">{label}{required && <span className="text-gold ml-1">*</span>}</label>
    <input
      type={type}
      required={required}
      data-testid={testid}
      className="mt-2 w-full bg-ink-800 border border-bone-100/12 rounded-full px-5 py-3 text-sm text-bone-100 placeholder:text-bone-300/50 outline-none focus:border-gold/60"
    />
  </div>
);
